import * as React from 'react';
import * as classnames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { Caption } from 'elc-typography';
import { ContentSpacing } from 'elc-base-theme';
import { reviewsTextTheme } from '../theme/default-theme';

export interface IReviews {
    className?: string;
    reviewsNumber: number;
    reviewsNumberLabel?: string;
}

const ReviewsWrapper = styled.div`
    display: inline-block;
    vertical-align: middle;
    margin: 0 ${ContentSpacing.space8};
`;

const ReviewsText = styled(Caption)`
    ${reviewsTextTheme};
`;

const StyledReviewsLabel = styled.span`
    display: none;
`;

export const ReviewsNumber = observer((props: IReviews) => {
    const classNames = classnames('elc-rating-reviews', 'js-rating-reviews', props.className);
    const reviewsNumberClassNames = classnames('elc-reviews-number', 'js-reviews-number');
    const reviewsNumberLabelClassnames = classnames(
        'elc-reviews-number-label',
        'js-reviews-number-label'
    );
    const { reviewsNumberLabel, reviewsNumber } = props;

    return (
        <ReviewsWrapper className={classNames}>
            <ReviewsText className={reviewsNumberClassNames}>
                (<span>{reviewsNumber}</span>
                {reviewsNumberLabel && (
                    <StyledReviewsLabel
                        className={reviewsNumberLabelClassnames}
                    >{` ${reviewsNumberLabel}`}</StyledReviewsLabel>
                )}
                )
            </ReviewsText>
        </ReviewsWrapper>
    );
});
